<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pt-4 pb-2" >
                <v-col sm="6" md="4" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('relocations.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="4" align="end" class="py-0">
                    <v-row class="mx-0 px-0 my-0 py-0" justify="end" align="end">
                        <btn-secondary @click="to_relocate_all_in_location" :label="'relocations.relocate_all'" :icon="'move_down'"></btn-secondary>
                        <btn-secondary @click="to_relocate_with_scanner" :label="'relocations.new_with_scanner'" :icon="'mnew_labeln'"></btn-secondary>
                        <btn-primary @click="to_relocate" :label="'relocations.new'" :icon="'add_box'"></btn-primary>
                    </v-row>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :pagination="[10, 20, 50, 100]" :props="{headers:headers, items: props.items, search:props.search}" :itemsLength="props.meta.total" :options.sync="pagination.pendings" @update:options="(options) => onOptionsChange(options)" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
            </v-container>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>

import { indexRelocationsUseCase } from '../application/use_cases/index_relocations_use_case'
import { HttpRelocationRepository } from '../infrastructure/repositories/relocation_repository';

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]},
        headers(){
            return [
                { text: this.$t('relocations.date'), align: "center", value: 'created_at', class: 'text-uppercase' },
                { text: this.$t('relocations.customer'), align: "center", value: 'c_name', class: 'text-uppercase' },
                { text: this.$t('relocations.sku'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('relocations.quantity'), align: "center", value: 'quantity', class: 'text-uppercase' },
                { text: this.$t('relocations.batch'), align: "center", value: 'batch', class: 'text-uppercase' },
                { text: this.$t('relocations.reference'), align: "center", value: 'reference', class: 'text-uppercase' },
                { text: this.$t('relocations.origin'), align: "center", value: 'o_name', class: 'text-uppercase' },
                { text: this.$t('relocations.destination'), align: "center", value: 'd_name', class: 'text-uppercase' },
                { text: this.$t('relocations.user'), align: "center", value: 'u_name', class: 'text-uppercase' }
            ];
        } 
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            idRelocation: '',
            props: {
                search: '',
                items: [],
                meta: {
                    total: 0,
                    total_pages: 0,
                    per_page: 10,
                    page: 1
                },
                sort_by: []
            },
            debounceTimer: null,
            pagination: {page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [], groupBy: [], groupDesc: [], multiSort: false, mustSort: false}
        }
    },
    mounted(){
        this.$store.state.module = "headers.relocations";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async index(){
            try{
                this.props.items = [];

                const res = await indexRelocationsUseCase(this.props.meta.page, this.props.meta.per_page, this.props.search, this.props.sort_by, HttpRelocationRepository);

                this.props.items = res.data;
                this.props.meta = res.meta;
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        to_relocate_all_in_location() {
            this.$router.push("/relocations/all_in_location");
        },
        to_relocate_with_scanner() {
            this.$router.push("/relocations/create_with_scanner");
        },
        to_relocate() {
            this.$router.push("/relocations/create");
        },
        async onOptionsChange(options) {
            this.props.meta.page = options.page;
            this.props.meta.per_page = options.itemsPerPage;
            
            if(options.sortBy.length > 0){
                this.props.meta.page = 1;
                this.props.sort_by = [{field: options.sortBy[0], direction: options.sortDesc[0] ? 'desc' : 'asc'}];
            } 
            else if(options.sortBy.length != this.props.sort_by.length) {
                this.props.meta.page = 1;
                this.props.sort_by = [];
            } 
            
            this.index();
        },
    },
    watch: {
        'props.search': async function(){
            clearTimeout(this.debounceTimer)

            this.debounceTimer = setTimeout(() => {
                this.index();
            }, 800);
        }
    }
}

</script>

<style>

</style>